export default __webpack_public_path__ + "static/media/file_00001 (4).3bc933b9.pdf";